export default  class AjaxLoad {
    constructor(element) {
        this.$element = $(element);
    }

    init() {
        let url = this.$element.data('ajaxload');

        $.get(url, response => {
            let $response = $(response);

            $response.replaceAll(this.$element);
            $response.trigger('enhance:ajaxload');

            $response.find('[data-ajaxload]').each((i, el) => {
                let ajaxLoad = new AjaxLoad(el);
                ajaxLoad.init();
            });
        });
    }
}
